import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { dashboardService } from "../services/dashboardService";

export function useProjectDashboardStats(projectId) {
  return useQuery({
    queryKey: ["projectDashboardStats", projectId],
    queryFn: () => dashboardService.getProjectDashboardStats(projectId),
    enabled: Boolean(projectId),
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
  });
}
